/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Office_Provision_SaleInputs */

const cs_settings_office_provision_sale = /** @type {(inputs: Settings_Office_Provision_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`% u prodeje / koupě`)
};

const en_settings_office_provision_sale = /** @type {(inputs: Settings_Office_Provision_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sale / purchase %`)
};

/**
* | output |
* | --- |
* | "Sale / purchase %" |
*
* @param {Settings_Office_Provision_SaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_office_provision_sale = /** @type {((inputs?: Settings_Office_Provision_SaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Office_Provision_SaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_office_provision_sale(inputs)
	return cs_settings_office_provision_sale(inputs)
});